import React from 'react';
import { ReactComponent as CaretIcon } from './caret.svg';
import emergency from './emergency.png';
import { OkCircle as OkCircleIcon } from './okCircle';

export const Caret = ({ className }) => <CaretIcon className={className} />;

export const Emergency = () => <img src={emergency} alt="emergency icon" />;

export const OkCircle = ({ className }) => <OkCircleIcon className={className} />;
